import type { PromptHistoryResponse } from '@atlassian/conversation-assistant-service-api/types/assistance-service';

type ApiPromptHistoryResponse = {
	items: Array<{
		message_id: string;
		session_id: string;
		display_text: string;
		truncated: boolean;
		created_at: number;
		is_opening_prompt?: boolean;
	}>;
	cursor?: string | null;
	hasNext: boolean;
};

type GetPromptHistoryOptions = {
	limit: number;
	signal?: AbortSignal;
	headers: Headers;
	fetchJson: (request: {
		baseUrl: string;
		path: string;
		options: RequestInit;
		holdName: string;
	}) => Promise<ApiPromptHistoryResponse>;
};

/** Uses the service's authenticated transport and normalizes the ACPS response. */
export async function getPromptHistory({
	limit,
	signal,
	headers,
	fetchJson,
}: GetPromptHistoryOptions): Promise<PromptHistoryResponse> {
	const searchParams = new URLSearchParams();
	searchParams.set('limit', String(limit));

	const result = await fetchJson({
		baseUrl: '/gateway/api/acps',
		path: `/rovo/v1/session/prompt-history?${searchParams.toString()}`,
		options: { method: 'GET', headers, signal },
		holdName: 'rovo-v1-session-prompt-history',
	});

	return {
		items: result.items.map((item) => ({
			messageId: item.message_id,
			sessionId: item.session_id,
			displayText: item.display_text,
			truncated: item.truncated,
			createdAt: item.created_at,
			isOpeningPrompt: item.is_opening_prompt === true,
		})),
		cursor: result.cursor ?? null,
		hasNext: result.hasNext,
	};
}
